import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'checkout_prime_subscription';
export const route = 'prime_subscription/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "checkout_prime_subscription_page" */
/* webpackPrefetch: true */
'../components/PrimeSubscriptionPage')));